import React, { useMemo } from 'react';
import {
  Box,
  Typography,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';

const getTodayDateString = () => {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

const AdditionalInfoSection = ({ formData, onInputChange }) => {
  const todayMaxDate = useMemo(() => getTodayDateString(), []);

  return (
    <Box sx={{ mb: 4 }}>
      <Typography
        sx={{
          fontSize: '18px',
          fontFamily: 'Inter',
          fontWeight: 600,
          mb: 2,
          display: 'flex',
        }}
      >
        Additional Information
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth size="small" required>
            <InputLabel>Region *</InputLabel>
            <Select
              value={formData.region}
              label="Region"
              onChange={(e) => onInputChange('additional', 'region', e.target.value)}
              sx={{
                '& .MuiSelect-select': {
                  textAlign: 'left',
                },
              }}
            >
              <MenuItem value="">Select</MenuItem>
              <MenuItem value="North">North</MenuItem>
              <MenuItem value="South">South</MenuItem>
              <MenuItem value="Central A">Central A</MenuItem>
              <MenuItem value="Central B">Central B</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="Jazz RO regional POC"
            placeholder="..."
            value={formData.jazzRORegionalPOC}
            onChange={(e) => onInputChange('additional', 'jazzRORegionalPOC', e.target.value)}
            size="small"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="Submitters email"
            placeholder="..."
            type="email"
            value={formData.submittersEmail}
            onChange={(e) => onInputChange('additional', 'submittersEmail', e.target.value)}
            size="small"
          />
        </Grid>
        {/* <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="Site IDS"
            placeholder="..."
            value={formData.siteIds}
            onChange={(e) => onInputChange('additional', 'siteIds', e.target.value)}
            size="small"
          />
        </Grid> */}
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="ATP status"
            placeholder="..."
            value={formData.atpStatus}
            onChange={(e) => onInputChange('additional', 'atpStatus', e.target.value)}
            size="small"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="PAC status"
            placeholder="..."
            value={formData.pacStatus}
            onChange={(e) => onInputChange('additional', 'pacStatus', e.target.value)}
            size="small"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="FAC Status"
            placeholder="..."
            value={formData.facStatus}
            onChange={(e) => onInputChange('additional', 'facStatus', e.target.value)}
            size="small"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="NOC/ROW issuance date"
            placeholder="..."
            type="date"
            value={formData.nocRowIssuanceDate}
            onChange={(e) => onInputChange('additional', 'nocRowIssuanceDate', e.target.value)}
            size="small"
            inputProps={{ max: todayMaxDate }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="Completion PAC date"
            placeholder="..."
            type="date"
            value={formData.completionPacDate}
            onChange={(e) => onInputChange('additional', 'completionPacDate', e.target.value)}
            size="small"
            inputProps={{ max: todayMaxDate }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="Remaining PO Amount"
            placeholder="..."
            value={formData.remainingPOAmount}
            size="small"
            disabled
            readOnly
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'transparent',
                '&.Mui-disabled': {
                  backgroundColor: 'transparent',
                  '& fieldset': {
                    borderColor: 'rgba(0, 0, 0, 0.23)',
                  },
                  '&:hover fieldset': {
                    borderColor: 'rgba(0, 0, 0, 0.23)',
                  },
                },
              },
              '& .MuiInputBase-input.Mui-disabled': {
                WebkitTextFillColor: 'rgba(0, 0, 0, 0.87)',
                color: 'rgba(0, 0, 0, 0.87)',
              },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default AdditionalInfoSection;
